import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Box from "@mui/material/Box";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useDispatch, useSelector } from "react-redux";
import { setAuthDialog } from "../../redux/actions/userActionCreators";

const AuthMedthodeErrorModal = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isMobile = useMediaQuery("(max-width:900px)");
  const authDialog = useSelector((state) => state.user.authDialog);

  const handleClose = () => {
    dispatch(setAuthDialog(false));
  };

  return (
    <div>
      <Dialog
        disableEnforceFocus
        open={authDialog}
        aria-labelledby="draggable-dialog-title"
        disableBackdropClick
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{ sx: { width: isMobile ? "80%" : "30%" } }}
      >
        <Box display="flex" alignItems="center" ml={3}>
          <Typography
            variant="subtitle3"
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 2,
              cursor: "pointer",
            }}
            onClick={handleClose}
          >
            <IconButton>
              <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
            </IconButton>
            {t("close")}
          </Typography>
        </Box>
        <DialogContent>
          <DialogContentText>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "25px",
                marginBottom: "10px",
              }}
            >
              <WarningAmberIcon color="error" fontSize="large" />
              <Typography variant="body5">{t("auth_method_error")}</Typography>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AuthMedthodeErrorModal;
